import React from 'react';
import { Route } from "react-router-dom";
import CategoryListView from '../views/CategoryListView';
import ColorsListView from '../views/ColorsListView';
import VendorsListView from '../views/VendorsListView';
import BrandsListView from '../views/BrandsListView';
import BrandModelsListView from '../views/BrandModelsListView';
import UnitsListView from '../views/UnitsListView';
import WarehouseContainersListView from '../views/WarehouseContainersListView';
import InventoryItemsListView from '../views/InventoryItemsListView';
import InventoryMainView from '../views/InventoryMainView';


function InventoryRoutes() {
  let k = 0;
  return (
    [
      <Route key={k++} path="/inventory" element={<InventoryMainView />}>
        <Route path="items" element={<InventoryItemsListView />} />
        <Route path="containers" element={<WarehouseContainersListView />} />
        <Route path="base/categories" element={<CategoryListView />} />
        <Route path="base/brands" element={<BrandsListView />} />
        <Route path="base/models" element={<BrandModelsListView />} />
        <Route path="base/vendors" element={<VendorsListView />} />
        <Route path="base/colors" element={<ColorsListView />} />
        <Route path="base/units" element={<UnitsListView />} />
      </Route>
    ]
  );
}

export default InventoryRoutes;
